<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <text-title :mainTitle="mainTitle" :subheading="subheading"/>
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">房间号：</span>
        </div>
        <el-cascader
          style="width: 280px"
          v-model="room"
          :options="options"
          :props="{ expandTrigger: 'hover' }"
          @change="handleChange"></el-cascader>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">设备型号：</span>
        </div>
        <el-input v-model="formData.deviceModel" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">设备厂商：</span>
        </div>
        <el-input v-model="formData.deviceFactroy" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">关联集中器：</span>
        </div>
        <el-input v-model="formData.concentratorCode" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
           <b class="red">*</b>
          <span class="line-text">识别方式：</span>
        </div>
        <el-checkbox-group v-model="formData.identifyMethod">
          <el-checkbox label="卡">卡</el-checkbox>
          <el-checkbox label="密码">密码</el-checkbox>
          <el-checkbox label="指纹">指纹</el-checkbox>
        </el-checkbox-group>
      </div>
    </form>
    <div class="form-btn-box">
      <button-confirm @confirm="confirm"/>
      <button-cancel @cancel="cancel"/>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import {getObjectURL} from "../../../utils/toBase64";
import {bus} from "../../../utils/bus";
import {api} from "../../api/Lock";
import {nError, nSuccess} from "../../../utils/notice";
import {errorHandler} from "../../../utils/errorHandler";
import login from "../../login";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "lock-gate-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧门锁",
          name: "lock-concentrator-manage"
        },
        {
          value: "门锁管理"
        }
      ],
      mainTitle: "添加门锁",
      subheading: "",
      formData: {
        identifyMethod:[]
      },
      equipmentCode: "",
      equipmentList: [],
      options:[],

      roomList:[],
      room:[]
    };
  },
  created() {
    this.getBuildingList()
  },
  methods: {
    getBuildingList(){
      this.$axios.post(api.getBuildingList,{}).then(res=>{
        let list=res.data.data
        let options=[]
        list.map(v=>{
          let  temp={}
          temp.label=v.name
          temp.value=v.code
          temp.children=[]
          options.push(temp)
          v.floors.map(u=>{
            let temp2={}
            temp2.label=u.name
            temp2.value=u.code
            temp2.children=[]
            temp.children.push(temp2)
          })
        })
        this.options=options
        this.getRoomInfoList()
      }).catch(errorHandler('获取楼栋列表失败'))
    },
    getRoomInfoList(){
      this.$axios.post(api.getRoomInfoList,{}).then(res=>{
        let list =res.data.data
        this.options.map(v=>{
          v.children.map(u=>{
            list.map(z=>{
              if(u.value==z.floorCode){
                let temp={}
                temp.value= z.code
                temp.label= z.roomNumber
                u.children.push(temp)
              }
            })
          })
        })
        this.roomList=list
      }).catch(errorHandler('获取房间列表失败'))
    },
    handleChange(value){
      this.room=value
      this.formData.roomCode=value[2]
      this.formData.floor_code=value[1]
      this.formData.building_code=value[0]
      this.roomList.map(v=>{
        if(v.code==value[2]){
          this.formData.roomNumber=v.buildingName+v.roomNumber
        }
      })
    },
    confirm() {
      if(!this.formData.roomCode){
        nError('请选择房间号')
        return false;
      }
      if(!this.formData.deviceCode){
        nError('请输入设备编号')
        return false;
      }
      if(Array.isArray(this.formData.identifyMethod)){
        this.formData.identifyMethod=this.formData.identifyMethod.join(',')
      }
      this.$axios
        .post(api.addLock, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "lock-gate-manage"
            });
          }
        })
        .catch(errorHandler("添加失败"))
        .finally(()=>{
        this.formData.identifyMethod=this.formData.identifyMethod.split(',')
      })
    },
    cancel() {
      this.$router.push({
        name: "lock-gate-manage"
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/GateLock/GateLockManage/LockGateAdd.vue